// Router.jsx

import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import Home from '../pages/home/page';
import LoginPage from '../pages/users/login/page';
import SignupPage from '../pages/users/signup/page';
import Footer from './Footer';
import DiscordIcon from './DiscordIcon';
import ProductsDetails from '../pages/products/details';
import ModelingProduct from '../pages/products/modeling/modeling';
import StandardTermContract from '../pages/stc';
import PP from '../pages/privacypolicy/pp';
import NoticePage from '../pages/notice/NoticePage';
import NoticeDetails from '../pages/notice/NoticeDetails';
import Category from '../pages/category';
import Profile from '../pages/users/profile';
import MyCart from '../pages/users/mycart';
import BadgePage from '../pages/badge';
import EventPage from '../pages/event/EventPage';
import FileUploader from './FileUploader';
import ProfileSetting from '../pages/profileSetting';
import SearchResultsPage from '../pages/products/modeling/SearchResultsPage';
import ProfileAccount from '../pages/profileAccount';

import NewsLetter from '../pages/newsletter';
import Seller from '../pages/seller';
import FileUploadForm from '../pages/admin/FileUploadForm';
import EmblemForm from '../pages/admin/EmblemForm';
import Eventform from '../pages/admin/EventForm';
import PurchaseDetails from '../pages/purchasedetails';
import PurchaseDetailsId from '../pages/purchasedetails/[id]/purchasedetailid';
import ProductUploadForm from '../pages/admin/ProductUploadForm';
import ManagerAdmin from '../pages/manager';

import MobilePlaceholder from './MobilePlaceholder';
import CouponPage from '../pages/coupon';
import { ToastContainer } from 'react-toastify';
import { UserProvider } from './UserContext';
import ProtectedRoute from './ProtectedRouteProps';
import SnsAdd from '../pages/snsaddpage/SnsAdd';
import ArticleForm from '../pages/admin/ArticleForm';
import Header from './header/Header';
import FailPage from '../pages/products/FailPage';
import SuccessPage from '../pages/products/SuccessPage';
import EventDetail from '../pages/event/EventDetail';
import InternetPageError from '../pages/error/interneterror';
import PageError from '../pages/error/pageerror';
import Cs from '../pages/notice/Cs';
import Notice from '../pages/notice/Notice';
import ProductsSeller from '../pages/productsseller';
import FindIdPwLayout from './FindIdPwLayout';
import FindId from './FindId';
import FindPw from './FindPw';
import ChatBot from './chatbot/ChatBot';
import ApplicationForm from '../pages/ApplicationForm/ApplicationForm';
import Popup from './Popup';
import Brand from '../pages/brand/Brand';
import HalloweenPage from '../pages/brand/Halloween/HalloweenPage';
import LoadingScreen from './LoadingScreen';
import ProductCard from './ProductCard';
import ReportModal from "../pages/products/reportModal";
import Modal from "./Modal";
import {Product} from "../types/types";
import ProjectsPage from '../pages/projects/ProjectsPage';

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // 페이지를 즉시 최상단으로 이동
  }, [pathname]);

  return null;
};


const ScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default function Router() {
  const location = useLocation();
  const navigate = useNavigate();
  const noHeaderRoutes = ['/login', '/signup']; // '/find' 제거
  const [forceDesktopView, setForceDesktopView] = useState(false);
  // const isMobile = useMediaQuery({query: '(max-width: 768px)'});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(true); // 초기 로드 시 팝업 표시
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingScreenClose = () => {
    setIsLoading(false); // LoadingScreen 해제
  };

  // 확인 버튼 클릭 시 팝업 닫기 핸들러
  const handleConfirm = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    if (!navigator.onLine) {
      window.location.href = '/wifi/error';
    }
  }, []);

  // backgroundLocation을 상태로 저장
  const state = location.state as { backgroundLocation?: Location, product?: Product };

  return (
    <>
      <ScrollToTopOnMount />
      <ScrollToTopOnRouteChange />
      {isPopupOpen && (
        <Popup
          message="여기에 팝업 메시지를 입력하세요." // 원하는 메시지로 변경
          onConfirm={handleConfirm}
        />
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* <ScrollToTopOnRouteChange /> */}
      <UserProvider>
        {/* {isLoading && <LoadingScreen onClose={handleLoadingScreenClose} />} */}
        {!noHeaderRoutes.includes(location.pathname) && <Header />}
        <Routes location={state?.backgroundLocation || location}>
          {/* 메인 홈 페이지 */}
          <Route path="/" element={<Home />} />
          {/* 로그인 페이지 */}
          <Route path="/login" element={<LoginPage />} />
          {/* 회원가입 페이지 */}
          <Route path="/signup" element={<SignupPage />} />
          {/* 아이디/비밀번호 찾기 - 새로운 레이아웃과 네스팅된 라우트 */}
          <Route path="/find" element={<FindIdPwLayout />}>
            {/* 기본 리디렉션: /find 에 접근 시 /find/id로 이동 */}
            <Route index element={<Navigate to="id" replace />} />
            <Route path="id" element={<FindId />} />
            <Route path="pw" element={<FindPw />} />
          </Route>
          {/* 카테고리 */}
          <Route path="/category" element={<Category />} />
          {/* 상품 페이지 */}
          <Route path="/products/details/:id" element={<ProductsDetails />} />
          <Route path="/products/:category" element={<ModelingProduct />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/fail" element={<FailPage />} />
          {/* 공지사항 페이지 */}
          <Route path="/notice" element={<NoticePage />} />
          <Route path="/notice/:id" element={<NoticeDetails />} />
          {/* 이용약관 */}
          <Route path="/service" element={<StandardTermContract />} />
          {/* 개인 정보 보호 정책 */}
          <Route path="/privacypolicy" element={<PP />} />
          {/* 프로필 */}
          <Route path="/profile/:id" element={<Profile />} />
          {/* 장바구니 */}
          <Route
            path="/my/cart"
            element={
              <ProtectedRoute>
                <MyCart />
              </ProtectedRoute>
            }
          />
          {/* 검색 */}
          <Route path="/search" element={<SearchResultsPage />} />
          {/* 엠블럼 */}
          <Route
            path="/emblem"
            element={
              <ProtectedRoute>
                <BadgePage />
              </ProtectedRoute>
            }
          />
          {/* 파트너 신청 */}
          <Route
            path="/partner-apply"
            element={
              <ProtectedRoute>
                <ApplicationForm />
              </ProtectedRoute>
            }
          />
          {/* 이벤트 */}
          <Route path="/event" element={<EventPage />} />
          <Route path="/event/:id" element={<EventDetail />} />
          {/* 업로드 */}
          <Route path="/upload" element={<FileUploader />} />
          {/* 프로필세팅 * 설정(디폴트 값 프로필세팅 페이지) */}
          <Route
            path="/setting/setting"
            element={
              <ProtectedRoute>
                <ProfileSetting />
              </ProtectedRoute>
            }
          />
          {/* 계정 */}
          <Route
            path="/setting/account"
            element={
              <ProtectedRoute>
                <ProfileAccount />
              </ProtectedRoute>
            }
          />
          {/* SNS */}
          <Route
            path="/setting/sns"
            element={
              <ProtectedRoute>
                <SnsAdd />
              </ProtectedRoute>
            }
          />
          {/* 쿠폰 */}
          <Route
            path="/setting/coupon"
            element={
              <ProtectedRoute>
                <CouponPage />
              </ProtectedRoute>
            }
          />
          {/* 세팅 셀러 */}
          <Route
            path="/setting/seller"
            element={
              <ProtectedRoute>
                <Seller />
              </ProtectedRoute>
            }
          />
          {/* 뉴스레터 */}
          <Route path="/setting/newslatter" element={<NewsLetter />} />
          {/* 브랜드 */}
          {/* <Route path="/brandzone" element={<Brand />} /> */}
          <Route path="/brandzone/halloween" element={<HalloweenPage />} />
          {/* 구매내역 */}
          <Route path="/purchase/details" element={<PurchaseDetails />} />
          {/* 구매내역 > 자세히보기 */}
          <Route path="/purchase/details/:id" element={<PurchaseDetailsId />} />
          {/* 관리자 */}
          <Route path="/manager/fileuploadform" element={<FileUploadForm />} />
          <Route path="/manager/Product" element={<ProductUploadForm />} />
          <Route path="/manager/page" element={<ManagerAdmin />} />
          <Route path="/manager/Emblem" element={<EmblemForm />} />
          <Route path="/manager/event" element={<Eventform />} />
          <Route path="/manager/Article" element={<ArticleForm />} />
          {/* 신고하기 라우트 추가 */}
          <Route
            path="/report/:productId"
            element={<Navigate to="/" replace />}
          />
          {/* 잘못된 경로 처리 */}
          <Route path="*" element={<Navigate to="/404/error" replace />} />
          <Route path="/wifi/error" element={<InternetPageError />} />
          <Route path="/404/error" element={<PageError />} />
          {/* 고객센터 및 공지사항 */}
          <Route path="/cs" element={<Cs />} />
          <Route path="/notice/list" element={<Notice />} />
          {/* 셀러페이지 */}
          <Route path="/seller" element={<ProductsSeller />} />
          {/* 프로젝트 페이지 */}
          <Route path="/projects" element={<ProjectsPage />} />
        </Routes>

        {/* 모달 라우트 처리 */}
        {location.pathname.startsWith('/report/') && (
          <Modal isOpen={true} onClose={() => navigate(-1)} width="450px">
            <ReportModal
              closeReportModal={() => navigate(-1)}
              product={state?.product}
            />
          </Modal>
        )}
      </UserProvider>
      <Footer />
      <DiscordIcon />
      <ChatBot />
    </>
  );
}
